import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/position";

export const getAllPosition = () => axios.get(API_PATH + "/get-all-position");

export const pagingPosition = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getPositionById = (positionId) => axios.get(API_PATH + "/get-by-id/" + positionId);

export const savePosition = position => axios.post(API_PATH + '/save', position);

export const savePositionIsActive = positionIsActive => axios.post(API_PATH + "/update-is-active", positionIsActive);

export const deletePosition = positionId => axios.delete(API_PATH + '/mark-delete/' + positionId);

export const getPositionByCode = positionCode => axios.get(API_PATH + '/find-by-code/' + positionCode);